package fr.frux.core.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Long

public class FavoriteQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun selectAll(): Query<Long> = Query(350_834_766, arrayOf("favorite"), driver, "favorite.sq", "selectAll", "SELECT tree_id FROM favorite") { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public fun insert(tree_id: Long?): QueryResult<Long> {
    val result = driver.execute(802_650_640, """INSERT OR IGNORE INTO favorite(tree_id) VALUES (?)""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, tree_id)
        }
    notifyQueries(802_650_640) { emit ->
      emit("favorite")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun delete(tree_id: Long): QueryResult<Long> {
    val result = driver.execute(650_984_706, """DELETE FROM favorite WHERE tree_id = ?""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, tree_id)
        }
    notifyQueries(650_984_706) { emit ->
      emit("favorite")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun clearAll(): QueryResult<Long> {
    val result = driver.execute(-1_498_363_477, """DELETE FROM favorite""", 0)
    notifyQueries(-1_498_363_477) { emit ->
      emit("favorite")
    }
    return result
  }
}
